"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Dropdown_component_exports = {};
__export(Dropdown_component_exports, {
  Dropdown: () => Dropdown
});
module.exports = __toCommonJS(Dropdown_component_exports);
var import_react = __toESM(require("react"));
var import_uniqueId = __toESM(require("lodash/uniqueId"));
var import_atoms = require("../../atoms");
var import_DropdownContent = require("../DropdownContent/DropdownContent.component");
var import_Dropdown = require("./Dropdown.styled");
var _excluded = ["className", "customizeHeight", "customizedWidth", "disabled", "icon", "list", "titleLabel", "placeholder", "selectedItem", "size", "itemType", "toggleItem", "onlyPlaceholder", "hintText", "hintIcon", "errorText", "borderLess", "darkMode", "placement", "optionsIcon", "showOptionSeparators", "optionsMinorTitle", "isSearchable", "multiSelect", "countSelectedItems", "optionsOverflow", "tabIndex"];
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var Dropdown = function Dropdown2(_ref) {
  var _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, customizeHeight = _ref.customizeHeight, customizedWidth = _ref.customizedWidth, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, icon = _ref.icon, list = _ref.list, _ref$titleLabel = _ref.titleLabel, titleLabel = _ref$titleLabel === void 0 ? "" : _ref$titleLabel, placeholder = _ref.placeholder, selectedItem = _ref.selectedItem, _ref$size = _ref.size, size = _ref$size === void 0 ? "regular" : _ref$size, _ref$itemType = _ref.itemType, itemType = _ref$itemType === void 0 ? "button" : _ref$itemType, toggleItem = _ref.toggleItem, _ref$onlyPlaceholder = _ref.onlyPlaceholder, onlyPlaceholder = _ref$onlyPlaceholder === void 0 ? false : _ref$onlyPlaceholder, _ref$hintText = _ref.hintText, hintText = _ref$hintText === void 0 ? "" : _ref$hintText, hintIcon = _ref.hintIcon, _ref$errorText = _ref.errorText, errorText = _ref$errorText === void 0 ? "" : _ref$errorText, _ref$borderLess = _ref.borderLess, borderLess = _ref$borderLess === void 0 ? false : _ref$borderLess, _ref$darkMode = _ref.darkMode, darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, optionsIcon = _ref.optionsIcon, _ref$showOptionSepara = _ref.showOptionSeparators, showOptionSeparators = _ref$showOptionSepara === void 0 ? false : _ref$showOptionSepara, optionsMinorTitle = _ref.optionsMinorTitle, _ref$isSearchable = _ref.isSearchable, isSearchable = _ref$isSearchable === void 0 ? false : _ref$isSearchable, _ref$multiSelect = _ref.multiSelect, multiSelect = _ref$multiSelect === void 0 ? false : _ref$multiSelect, _ref$countSelectedIte = _ref.countSelectedItems, countSelectedItems = _ref$countSelectedIte === void 0 ? false : _ref$countSelectedIte, _ref$optionsOverflow = _ref.optionsOverflow, optionsOverflow = _ref$optionsOverflow === void 0 ? "ellipsis" : _ref$optionsOverflow, _ref$tabIndex = _ref.tabIndex, tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex, props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, import_react.useState)(list), _useState2 = _slicedToArray(_useState, 2), filteredList = _useState2[0], setFilteredList = _useState2[1];
  var isLarge = size === "large";
  var errorMode = !!errorText;
  if (!selectedItem && !placeholder && !isSearchable && !countSelectedItems) {
    selectedItem = list[0];
  }
  var dropDownActivator = function dropDownActivator2(_ref2) {
    var activatorRef = _ref2.activatorRef, isDisabled = _ref2.isDisabled, listOpened = _ref2.listOpened, selectedValue = _ref2.selectedValue, toggleList = _ref2.toggleList;
    var _useState3 = (0, import_react.useState)(), _useState4 = _slicedToArray(_useState3, 2), selectedText = _useState4[0], setSelectedText = _useState4[1];
    (0, import_react.useEffect)(function() {
      setSelectedText(selectedValue);
    }, [selectedValue]);
    var titleRef = (0, import_react.useRef)(null);
    var titleWrapperRef = (0, import_react.useRef)(null);
    var _useState5 = (0, import_react.useState)(false), _useState6 = _slicedToArray(_useState5, 2), isEllipsisActive = _useState6[0], setIsEllipsisActive = _useState6[1];
    var dropdownId = "wrapper-title-".concat(props.id || (0, import_uniqueId.default)());
    var getFilteredList = function getFilteredList2(value) {
      var filteredOptionsList = list;
      if (value) {
        var lowerCaseValue = value.toLowerCase();
        filteredOptionsList = list.filter(function(_ref3) {
          var name = _ref3.name, description = _ref3.description, children = _ref3.children;
          return name && name.toLowerCase().includes(lowerCaseValue) || typeof description === "string" && description.toLowerCase().includes(lowerCaseValue) || typeof children === "string" && children.toLowerCase().includes(lowerCaseValue);
        });
      }
      return filteredOptionsList;
    };
    var handleInputChange = function handleInputChange2(e) {
      var value = e.target.value;
      setSelectedText(value);
      var optionsList = getFilteredList(value);
      if (!listOpened && optionsList.length > 0 || listOpened && optionsList.length === 0) {
        toggleList();
      }
      setFilteredList(optionsList);
    };
    var handleDropdownClick = function handleDropdownClick2() {
      setFilteredList(list);
      toggleList();
    };
    (0, import_react.useEffect)(function() {
      var titleElement = titleRef && titleRef.current;
      if (titleElement) {
        var ellipsisStatus = titleElement.offsetWidth < titleElement.scrollWidth;
        setIsEllipsisActive(ellipsisStatus);
      }
    }, []);
    (0, import_react.useEffect)(function() {
      setFilteredList(list);
    }, [list]);
    var getTitle = function getTitle2() {
      if (isEllipsisActive) {
        return /* @__PURE__ */ import_react.default.createElement(import_atoms.Tooltip, {
          value: titleLabel
        }, /* @__PURE__ */ import_react.default.createElement(import_Dropdown.StyledLabelTitle, {
          ref: titleRef
        }, titleLabel));
      }
      return /* @__PURE__ */ import_react.default.createElement(import_Dropdown.StyledLabelTitle, {
        ref: titleRef
      }, titleLabel);
    };
    return /* @__PURE__ */ import_react.default.createElement(import_Dropdown.StyledDropdown, {
      "aria-expanded": listOpened && !isDisabled,
      "aria-disabled": isDisabled,
      "aria-haspopup": "listbox",
      "aria-labelledby": dropdownId,
      customizeHeight,
      customizedWidth,
      "data-toggle": "dropdown",
      disabled: isDisabled,
      isLarge,
      onClick: handleDropdownClick,
      ref: activatorRef,
      errorMode,
      borderLess,
      darkMode,
      className: "styled-dropdown",
      tabIndex,
      role: "combobox"
    }, /* @__PURE__ */ import_react.default.createElement(import_Dropdown.StyledDropdownTitle, null, icon && /* @__PURE__ */ import_react.default.createElement(import_Dropdown.StyledIcon, {
      icon,
      disabled: isDisabled,
      darkMode,
      errorMode
    }), /* @__PURE__ */ import_react.default.createElement(import_Dropdown.StyledWrapperTitle, {
      ref: titleWrapperRef,
      darkMode,
      errorMode,
      disabled: isDisabled,
      id: dropdownId
    }, titleLabel && getTitle(), isSearchable ? /* @__PURE__ */ import_react.default.createElement(import_Dropdown.StyledInput, {
      type: "text",
      disabled: isDisabled,
      placeholder,
      value: selectedText || "",
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      onChange: handleInputChange
    }) : /* @__PURE__ */ import_react.default.createElement("span", null, onlyPlaceholder || !selectedText ? placeholder : selectedText)), /* @__PURE__ */ import_react.default.createElement(import_Dropdown.StyledChevronIcon, {
      icon: listOpened && !isDisabled ? "chevron-up" : "chevron-down",
      disabled: isDisabled,
      darkMode,
      errorMode
    })));
  };
  return /* @__PURE__ */ import_react.default.createElement(import_DropdownContent.DropdownContent, {
    activator: dropDownActivator,
    className,
    disabled,
    list: filteredList,
    itemType,
    maxHeight: "190px",
    offset: [0, 5],
    placeholder,
    selectedItem,
    toggleItem,
    width: isLarge ? "172px" : customizedWidth || "152px",
    hintText,
    hintIcon,
    errorText,
    darkMode,
    errorMode,
    placement,
    optionsIcon,
    showOptionSeparators,
    optionsMinorTitle,
    navigateThroughListOptionsUsingTabKey: true,
    multiSelect,
    countSelectedItems,
    optionsOverflow,
    id: props.id
  });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Dropdown
});
//# sourceMappingURL=Dropdown.component.js.map